var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.75H13.5",
    stroke: "#253837",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.375H12.75",
    stroke: "#253837",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.25,
    width: 15,
    height: 13.5,
    rx: 5,
    stroke: "#253837",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11C4.65623 9.0642 8.03414 8.93682 9 11",
    stroke: "#253837",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 5.75C7.875 6.57843 7.20343 7.25 6.375 7.25C5.54657 7.25 4.875 6.57843 4.875 5.75C4.875 4.92157 5.54657 4.25 6.375 4.25C7.20343 4.25 7.875 4.92157 7.875 5.75Z",
    stroke: "#253837",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profileImg.14b11c6c77c5cb18748acce370b5fa87.svg";
export { ForwardRef as ReactComponent };